// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","header2":"Header_header2__thL1y","logo":"Header_logo__3_SJs","login":"Header_login__3V3Qa"};